import { render, staticRenderFns } from "./TextVisualSettingsModal.vue?vue&type=template&id=1bb135f6&"
import script from "./TextVisualSettingsModal.vue?vue&type=script&lang=js&"
export * from "./TextVisualSettingsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports